import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import i18n from "../../i18n";
import getAPIbaseURL from "../../utils/helpers";

const API_URL = `${getAPIbaseURL()}/organization`;

export const fetchOrganizationSettings = createAsyncThunk(
    "organizationSettings/fetchOrganizationSettings",
    async (_, thunkAPI) => {
        try {
            const token = localStorage.getItem("token");
            const response = await axios.get(`${API_URL}/`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || i18n.t("slices.organizationSettingsSlice.fetchedError"));
        }
    }
);

export const createOrganizationSettings = createAsyncThunk(
    "organizationSettings/createOrganizationSettings",
    async (settingsData, thunkAPI) => {
        try {
            const token = localStorage.getItem("token");
            const response = await axios.post(`${API_URL}/`, settingsData, {
                headers: { Authorization: `Bearer ${token}` },
            });
            toast.success(i18n.t("slices.organizationSettingsSlice.createdSuccess"));
            return response.data;
        } catch (error) {
            toast.error(i18n.t("slices.organizationSettingsSlice.createdError"));
            return thunkAPI.rejectWithValue(error.response?.data || i18n.t("slices.organizationSettingsSlice.createdError"));
        }
    }
);

export const updateOrganizationSettings = createAsyncThunk(
    "organizationSettings/updateOrganizationSettings",
    async (settingsData, thunkAPI) => {
        try {
            const token = localStorage.getItem("token");
            const response = await axios.put(`${API_URL}/`, settingsData, {
                headers: { Authorization: `Bearer ${token}` },
            });
            toast.success(i18n.t("slices.organizationSettingsSlice.updatedSuccess"));
            return response.data;
        } catch (error) {
            toast.error(i18n.t("slices.organizationSettingsSlice.updatedError"));
            return thunkAPI.rejectWithValue(error.response?.data || i18n.t("slices.organizationSettingsSlice.updatedError"));
        }
    }
);

const initialState = {
    item: null,
    isLoading: false,
    error: null,
};

const organizationSettingsSlice = createSlice({
    name: "organizationSettings",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchOrganizationSettings.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchOrganizationSettings.fulfilled, (state, action) => {
                state.isLoading = false;
                state.item = action.payload;
                state.error = null;
            })
            .addCase(fetchOrganizationSettings.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })

            .addCase(createOrganizationSettings.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(createOrganizationSettings.fulfilled, (state, action) => {
                state.isLoading = false;
                state.item = action.payload;
                state.error = null;
            })
            .addCase(createOrganizationSettings.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })

            .addCase(updateOrganizationSettings.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(updateOrganizationSettings.fulfilled, (state, action) => {
                state.isLoading = false;
                state.item = action.payload;
                state.error = null;
            })
            .addCase(updateOrganizationSettings.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            });
    },
});

export default organizationSettingsSlice.reducer;
